import { Component } from 'react';
import { connect } from 'react-redux';
import InterventionTextField from './InterventionReportFields/InterventionTextField';
import InterventionIntegerField from './InterventionReportFields/InterventionIntegerField';
import InterventionCheckBox from './InterventionReportFields/InterventionCheckBox';
import InterventionDatePicker from './InterventionReportFields/InterventionDatePicker';
import InterventionSelectField from './InterventionReportFields/InterventionSelectField';
import InterventionPhotoField from './InterventionReportFields/InterventionPhotoField';
import InterventionSignatureField from './InterventionReportFields/InterventionSignatureField';
import InterventionArrayField from './InterventionReportFields/InterventionArrayField';
import InterventionDecimalAndTextField from './InterventionReportFields/InterventionDecimalAndTextField';
import InterventionEquipmentField from './InterventionReportFields/InterventionEquipmentField';
import InterventionProdlotField from './InterventionReportFields/InterventionProdlotField';
import InterventionProductField from './InterventionReportFields/InterventionProductField';
import InterventionTimePicker from './InterventionReportFields/InterventionTimePicker';
import InterventionEmailField from './InterventionReportFields/InterventionEmailField';
import { DEFAULT_WIDGET_VALUE, SIGNATURES_BLOC_TYPE_CODE } from '../../redux/intervention/interventionConstants';
import { blocsAreDifferents, userCanUpdateBloc } from '../../redux/intervention/interventionActions';
import { throwErrorMessage } from '../../lib/error_helper';
import { getCurrentFunctionName } from '../../performanceModeManager';
import InterventionNbHoursField from './InterventionReportFields/InterventionNbHoursField';
import InterventionTextWithSuggestionsField from './InterventionReportFields/InterventionTextWithSuggestionsField';

function getField(props, state) {
    let bloc = props.blocs.find(b => b.mobile_id === props.blocId);

    if (!bloc) {
        state.throwErrorMessage({
            title: "Attention",
            message: "Un bloc est introuvable. Contactez le support applicatif afin" +
                " de vérifier la configuration pour le bloc [" + props.blocId + "] ",
        });

        return null;
    }

    let disabled = props.blocType.code === SIGNATURES_BLOC_TYPE_CODE ? false : !userCanUpdateBloc(props.activeUser, props.intervention, bloc, props.blocType)

    let commonProperties = {
        inputProperties: {
            id: props.id,
            required: props.required,
            disabled: disabled,
            className: props.visible ? "" : "intervention-field-hidden",
        },
        model: props.model,
        fieldValueChange: state.fieldValueChange,
        value: props.value,
        blocId: props.blocId,
        visible: props.visible,
        blocType: props.blocType,
    }

    let field = state.getFields(commonProperties).find((e) => e.code === props.model.value_type && e.widget === props.model.widget);

    if (!field) {
        state.throwErrorMessage({
            title: "Attention",
            message: "Un composant est introuvable. Contactez le support applicatif afin" +
                " de vérifier la configuration pour le champ [" + props.model.code + "] " + props.model.name,
        });

        return null;
    }

    return field;
}

class InterventionReportField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            throwErrorMessage: this.throwErrorMessage.bind(this),
            fieldValueChange: this.fieldValueChange.bind(this),
            getFields: this.getFields,
        }
    }

    componentDidMount() {
        this.setState({
            field: getField(this.props, this.state),
        })
    }

    throwErrorMessage(objError) {
        if (!this.state.errorMessageTimeout)
            this.setState({
                errorMessageTimeout: setTimeout(() => {
                    this.props.throwErrorMessage(objError);
                }, this.state.timeout)
            });
    }

    getFields(properties) {
        return [
            {
                code: "text",//Texte
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionTextField {...properties} />),
                properties,
            },
            {
                code: "integer",//Entier
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionIntegerField {...properties} type="number" />),
                properties,
            },
            {
                code: "float",//Décimal
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionTextField {...properties} type="number" />),
                properties,
            },
            {
                code: "boolean",//Booléen
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionCheckBox {...properties} />),
                properties,
            },
            {
                code: "date",//DatePicker
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionDatePicker {...properties} />),
                properties,
            },
            {
                code: "choice",//Liste de choix
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionSelectField {...properties} details={[]} />),
                properties,
            },
            {
                code: "choices",//Liste de choix
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionSelectField {...properties} multiple details={[]} />),
                properties,
            },
            {
                code: "fields",//Liste de champs
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionArrayField {...properties} />),
                properties,
            },
            {
                code: "picture",//Photo
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionPhotoField {...properties} />),
                properties,
            },
            {
                code: "signature",//Signature
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionSignatureField {...properties} />),
                properties,
            },
            {
                code: "quantity_value",//Quantité/Valeur
                widget: DEFAULT_WIDGET_VALUE,
                element: (<InterventionDecimalAndTextField {...properties} />),
                properties,
            },
            {
                code: "quantity_value",//Quantité/Valeur
                widget: "qr_code_equipment",
                element: (<InterventionDecimalAndTextField {...properties} />),
                properties,
            },
            {
                code: "quantity_value",//Quantité/Valeur
                widget: "qr_code_prodlot",
                element: (<InterventionDecimalAndTextField {...properties} />),
                properties,
            },
            {
                code: "text",//QrCode
                widget: "qr_code_equipment",
                element: (<InterventionEquipmentField {...properties} />),
                properties,
            },
            {
                code: "text",//QrCode
                widget: "qr_code_prodlot",
                element: (<InterventionProdlotField {...properties} />),
                properties,
            },
            {
                code: "text",//Product
                widget: "product",
                element: (<InterventionProductField {...properties} />),
                properties,
            },
            {
                code: "text",//Texte
                widget: "textarea",
                element: (<InterventionTextField {...properties} multiline />),
                properties,
            },
            {
                code: 'float',//Time
                widget: "time",
                element: (<InterventionTimePicker {...properties} />),
                properties,
            },
            {
                code: 'float',//Time interval
                widget: "time_with_interval_15",
                element: (<InterventionTimePicker {...properties} interval={15} />),
                properties,
            },
            {
                code: 'float',//Time interval
                widget: "hours_from_time_picker",
                element: (<InterventionNbHoursField {...properties} interval={15} />),
                properties,
            },
            {
                code: 'text',//email
                widget: "email",
                element: (<InterventionEmailField {...properties} type="email" autoComplete="email" />),
                properties,
            },
            {
                code: "text",//Texte avec suggestions
                widget: "textarea_with_suggestions",
                element: (<InterventionTextWithSuggestionsField {...properties} multiline />),
                properties,
            },
        ]
    }

    shouldComponentUpdate(nextProps) {
        let stateChanged = nextProps.intervention !== this.props.intervention
        let visibilityChanged = nextProps.visible !== this.props.visible;
        let requirementChanged = nextProps.required !== this.props.required;
        return visibilityChanged || requirementChanged || stateChanged
            || blocsAreDifferents(nextProps.blocs, this.props.blocs);
    }

    fieldValueChange(value) {
        this.props.fieldValueChange(this.props.model.id, value);
        this.forceUpdate();
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let field = getField(this.props, this.state);

        if (!field || !field.properties || !field.properties.visible || !field.element) {
            return null;
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                {field ? field.element : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        blocs: state.intervention.blocs,
        intervention: state.intervention.currentIntervention,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterventionReportField);
